interface ConsentData {
  consentId: string;
  acceptType: string;
  acceptedCategories: string[];
  rejectedCategories: string[];
  timestamp: string;
  userAgent: string;
}

interface ConsentPayload extends ConsentData {
  clientName: string;
  clientUrl: string;
}

interface ApiResponse {
  success?: boolean;
  status?: number;
  error?: string;
  data?: any;
}

async function createCookieConsent(
  consentData: ConsentData
): Promise<ApiResponse> {
  try {
    const apiUrl = import.meta.env.VITE_COOKIE_CONSENT_API_URL;

    if (!apiUrl) {
      throw new Error("VITE_COOKIE_CONSENT_API_URL não configurada");
    }

    const payload: ConsentPayload = {
      ...consentData,
      clientName: import.meta.env.VITE_CLIENT_SITE_NAME || "SoverX.ai",
      clientUrl: import.meta.env.VITE_CLIENT_SITE_URL || "https://soverx.ai",
    };

    const response = await fetch(`${apiUrl}/cookie-consent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Erro ao registrar cookie consent:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Erro desconhecido",
    };
  }
}

async function getCookieConsentLogs(): Promise<any[]> {
  try {
    const apiUrl = import.meta.env.VITE_COOKIE_CONSENT_API_URL;

    if (!apiUrl) {
      throw new Error("VITE_COOKIE_CONSENT_API_URL não configurada");
    }

    const response = await fetch(`${apiUrl}/cookie-consent`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (result.success) {
      return result.data;
    } else {
      console.error("Erro na resposta da API:", result.error);
      return [];
    }
  } catch (error) {
    console.error("Erro ao buscar registros de cookie consent:", error);
    return [];
  }
}

export { createCookieConsent, getCookieConsentLogs };
